module.exports = __webpack_public_path__ + "assets/images/save-file-icon.c799d7b02972cc9f23273f198eded784.svg";